import { render } from "./UndoVariant.vue?vue&type=template&id=3edff3b5"
import script from "./UndoVariant.vue?vue&type=script&lang=js"
export * from "./UndoVariant.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/UndoVariant.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3edff3b5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3edff3b5', __exports__)) {
    api.reload('3edff3b5', __exports__)
  }
  
  module.hot.accept("./UndoVariant.vue?vue&type=template&id=3edff3b5", () => {
    api.rerender('3edff3b5', render)
  })

}


export default __exports__